import { createSlice } from '@reduxjs/toolkit';
import { extractHandlersFromSlice } from '@madbox/react_redux_request_handling';

const sessionSlice = createSlice({
  name: 'session',
  initialState: {},
  reducers: {
    // LOGIN
    /**
     * @param state
     * @param {{mail: string, password: string} | {googleIdToken: string}} payload
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRequest(state, payload) {
      state.loading = true;
      state.logingIn = true;
      state.profile = null;
      state.authorizations = null;
      state.errors = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.logingIn = false;
      state.profile = action.payload.profile;
      state.organization = action.payload.organization;
      state.authorizations = action.payload.authorizations;
      state.headerMenu = action.payload.headerMenu;
    },
    loginError(state, action) {
      state.loading = false;
      state.logingIn = false;
      state.errors = action.payload;
    },

    // INIT
    initRequest(state) {
      state.loading = true;
      state.profile = null;
      state.organization = null;
      state.authorizations = null;
    },
    initSuccess(state, action) {
      state.loading = false;

      // Was not already connected
      if (action.payload) {
        state.profile = action.payload.profile;
        state.organization = action.payload.organization;
        state.authorizations = action.payload.authorizations;
        state.headerMenu = action.payload.headerMenu;
      }
    },
    initError(state) {
      state.loading = false;
    },

    // LOGOUT
    logoutRequest(state) {
      state.profile = null;
      state.authorizations = null;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginError,
  initRequest,
  initSuccess,
  initError,
  logoutRequest,
} = sessionSlice.actions;

export const { login, init, logout } = extractHandlersFromSlice(sessionSlice, ['login', 'init', 'logout']);

export const reducer = sessionSlice.reducer;
